import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { Button, ButtonClean, HeadContent, Icon, Loading, Tag } from '@fourthwall/components'
import { NewWindowIcon } from '@fourthwall/icons'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { YouTubeVideoEntry } from '../../components/YouTubeVideoEntry/YouTubeVideoEntry'
import { mapStatusToTagProps } from '../../utils/mapStatusToTagProps'
import * as S from './AppsVimmi.styled'
import { useVimmi } from './hooks/useVimmi'

export const AppsVimmi = () => {
  const { connectBar, status, isLoading, hmac } = useVimmi()
  const { currentShop } = useCurrentShop()

  if (!connectBar || !currentShop) {
    return <Loading isLoading={isLoading} />
  }

  const renderStatusTag = () => {
    if (status === 'CONNECTED') return null

    const props = mapStatusToTagProps(status)

    if (!props) return null

    return <Tag {...props} size="large" display="inline-flex" />
  }

  return (
    <>
      <HeadContent title="Vimmi" />
      <PageLayout size="tiny">
        <Dashboard.Section
          name="Vimmi Video Commerce"
          topContent={<DashboardBackButton label={SECTION_NAMES.apps} to={routing.apps.self} />}
          bottomContent={
            <p>
              <ButtonClean
                label="Learn More"
                href={routing.external.vimmi.learnMore}
                target="_blank"
              />
            </p>
          }
        >
          <Loading isLoading={isLoading}>
            {renderStatusTag()}
            <S.DescriptionWrapper>
              Drive more sales with live shopping and shoppable videos embedded on your site and
              shared across your social channels.
            </S.DescriptionWrapper>
            <S.VideoWrapper>
              <YouTubeVideoEntry
                title="Boost Your Sales with Shoppable Videos"
                videoId="MDcG4H_QV_k"
                description="Learn to transform live shopping events and shoppable videos into powerful sales tools that engage and convert."
                size="regular"
              />
            </S.VideoWrapper>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <ConnectBar {...connectBar} />
              {status === 'CONNECTED' && (
                <div style={{ padding: 16 }}>
                  <p>
                    <Button
                      appearance="primary"
                      label="Launch Vimmi & Start Selling!"
                      icon={<Icon component={NewWindowIcon} height={16} width={16} />}
                      href={`${routing.external.vimmi.dashboard}?source=fourthwall&hmac=${hmac?.signature}&timestamp=${hmac?.timestamp}&shop_id=${currentShop.id}`}
                      target="_blank"
                    />
                  </p>
                </div>
              )}
            </div>
          </Loading>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
